import React from "react";
import DetailedMoods from "../detailedView/DetailedMoods";
import Checkmark from "../misc/elements/Checkmark";
import OpacityImg from "../misc/elements/OpacityImg";

const ActiveButtons = ({
  setShowActiveGoal,
  onCompleted,
  box,
  stopActive,
  moods = true,
  width = "25%",
}) => {
  return (
    <div
      className="divColumn"
      style={{ width, justifyContent: "space-around", height: "100%" }}
    >
      {moods && (
        <DetailedMoods moodObject={box.moods} imgSize="24px" isSeconds={true} />
      )}
      <div
        className="divRow"
        style={{
          width: "100%",
          justifyContent: "space-around",
        }}
      >
        <OpacityImg
          height={"40px"}
          src="/icons/icon_hide.png"
          onClick={() => {
            setShowActiveGoal(false);
          }}
        />
        <OpacityImg
          src={"/icons/icon_stop.png"}
          onClick={() => stopActive(false)}
          height={"45px"}
        />

        <Checkmark
          divWidth={"50px"}
          size="40px"
          onChecked={onCompleted}
          useOpacity={true}
        />
      </div>
    </div>
  );
};

export default ActiveButtons;
